import { Select } from 'antd';
import React, {useId, useState} from 'react';
import { ISelectInputProps } from './types';
import { options } from 'numeral';
const { Option } = Select;
var index = -1
var fromKey = false

function SelectInput(props: ISelectInputProps) {

  const sendOnSelectChange = (value: any) => {
    //console.log(`${JSON.stringify(value)}  is an object ${typeof value === 'object'}`)
    if (typeof value === 'object'){
      props.onSelectChange(value.value);
    } else
      props.onSelectChange(value);

  }
  const handleKeyDown = (key: string) => {
    const currentIndexPosition = props.options.findIndex((option) => option.value === props.value);
    index = currentIndexPosition
    if (key === 'ArrowDown') {
      const nextIndex = currentIndexPosition + 1;
      //console.log("ArrowDown Key")

      if (nextIndex < props.options.length) {
        //onsole.log(`${JSON.stringify(props.options[nextIndex])}  is an object ${typeof props.options[nextIndex] === 'object'}`)
        //props.onSelectChange(props.options[nextIndex]);
        sendOnSelectChange(props.options[nextIndex])
        index = nextIndex
      }
    } else if (key === 'ArrowUp') {
      const previousIndex = currentIndexPosition - 1;
      //console.log("ArrowUp Key")
      if (previousIndex >= 0)  {
        //console.log(`${JSON.stringify(props.options[previousIndex])}  is an object ${typeof props.options[previousIndex] === 'object'}`)
        //props.onSelectChange(props.options[previousIndex]);
        sendOnSelectChange(props.options[previousIndex])
      }
      index = previousIndex
    } else if (key.length === 1) {
      const typedLetter = key.toLowerCase();
      const filteredOptions = props.options.filter((option) => option.name.toLowerCase().startsWith(typedLetter));
      
      if (filteredOptions.length > 0) {
        const selectedIndex = filteredOptions.findIndex((option) => option === props.value);
        const nextIndex = selectedIndex !== -1 ? selectedIndex + 1 : 0;
        const selectedOption = filteredOptions[nextIndex % filteredOptions.length];
        //console.log(`Enter Key ${key}`)
        sendOnSelectChange(selectedOption)
        //props.onSelectChange(selectedOption);
        index = props.options.findIndex((option) => option.name.toLowerCase().startsWith(typedLetter))
      }
    } else if (key === 'Enter') {
      if (props.selectOnEnter) {
        console.log("Enter Key")
        fromKey = true
        sendOnSelectChange(props.options[index])
        //if(props.options[index]?.value)
        //  props.onSelectChange(props.options[index].value)
        //else
        //  props.onSelectChange(props.options[index])
        //}
      }
    }
  }


    return (
    <div className="select-input-component" style={props.style}>
      {props.label && (
        <div className="select-input-component__label">
          {props.label}
        </div>
      )}
      <div {...props.innerProps} className="select-input-component__select">
        {props.options && 
          <Select 
            key={useId()}
            onInputKeyDown={(e) => handleKeyDown(e.key)} 
            autoFocus={props.autoFocus} 
            disabled={props.disabled} 
            value={props.value}
            defaultValue={props.options[0] || ''} 
            style={{width: props.width || 220}} 
            onChange={ (e) =>
                {
                  if(props.selectOnEnter) {
                    if(fromKey) {
                      sendOnSelectChange(props.options[index])
                    }
                    else {
                      sendOnSelectChange(e)
                    }
                    fromKey = false
                  } else {
                    sendOnSelectChange(e)
                  }
                }
          }
          >
            {props.options.map((option, index) => 
              <Option key={option.name + '-' + index + Math.random()} id={option.name + '-' + index} value={option.value}>{option.name}</Option>
            )}
          </Select>
        }
      </div>
    </div>
  )
}

export default SelectInput
